import { setUserAction, withAlertHandler } from 'entoro-shared';
import { withStyles } from 'material-ui/styles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { has } from 'lodash';
import { getNextOnboardingRoute } from '../Account/accountCompletionValidators';

const styles = (theme) => ({
  content: {
    padding: theme.spacing.unit,
  },
  formContainer: {
    padding: theme.spacing.unit * 2,
    overflow: 'hidden',
    width: 'inherit',
    transform: 'translate3d(0, 0, 0)',
  },
});

class AccountForm extends Component {
  update = async (variables, redirect = true) => {
    const {
      client,
      dispatch,
      handleSnackbarError,
      setSnackbarMessage,
      mutation,
      investorUser,
    } = this.props;
    const { mutate } = client;

    const { definitions } = mutation;
    const [firstDefinition] = definitions;
    const {
      name: { value },
    } = firstDefinition;

    try {
      const {
        data: { [value]: result },
      } = await mutate({
        mutation,
        variables,
      });

      dispatch(setUserAction(result));

      if (!redirect) {
        return;
      }

      setSnackbarMessage('Account updated successfully');

      const { canViewOffers } = investorUser;

      const canAccessOffers =
        !canViewOffers && has(result, 'canViewOffers') && result.canViewOffers;

      if (canAccessOffers) return;
      if (value == 'updateInvestorBasicInformation' && result.country != 'US') {
        dispatch(push('/account/suitability'));
      } else {
        dispatch(
          push(getNextOnboardingRoute(this.props) || '/dashboard/all-offers')
        );
      }
    } catch (error) {
      handleSnackbarError(error);
    }
  };

  render() {
    const { Form } = this.props;

    return <Form update={this.update} />;
  }
}

AccountForm.propTypes = {
  client: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  handleSnackbarError: PropTypes.func.isRequired,
  setSnackbarMessage: PropTypes.func.isRequired,
  mutation: PropTypes.object.isRequired,
  Form: PropTypes.func.isRequired,
};

const mapStateToProps = ({ investorUser, router }) => ({
  investorUser,
  location: router.location,
});

export default connect(mapStateToProps)(
  withApollo(withAlertHandler(withStyles(styles, {})(AccountForm)))
);



// WEBPACK FOOTER //
// ./src/components/Account/AccountForm.js